import { Injectable } from '@angular/core';
import { Result } from 'src/shared/model/result';

import { ESign_api } from '../constant/document-esign.const';

import { ApiService } from '@workflow/ecp-shared/service/api/api.service';
import { EsignEnvelope, RenewEsignPayload } from 'src/postapp/models/esign.model';
/**
 *
 * Document ESign Service
 * @export
 * @ class DocumentESignService
 */
@Injectable()
export class DocumentESignService {
  constructor(public api: ApiService) {}

  public geteSignIFrameUrl(
    envelopeId: string,
    eSignCallbackUrl: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback: (l: Result<any>) => void,
    errorCallBack: (l) => void
  ): void {
    this.api.requestApi({
      callback,
      errorCallback: errorCallBack,
      urlIds: { envelopeId, eSignCallbackUrl },
      urlObj: ESign_api.GeteSignUrl
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public updateESignStatus(envelopeId: string, callback: (l: Result<any>) => void, errorCallBack: (l) => void): void {
    this.api.requestApi({
      callback,
      errorCallback: errorCallBack,
      urlIds: { envelopeId },
      urlObj: ESign_api.UpdatESignStatus
    });
  }

  public updateESignStatusByApplicantId(
    applicantId: string,
    email: string,
    applicationID: string,
    cellNumber: string,
    status: string,
    callback: (l: Result<boolean>) => void,
    errorCallBack: (l) => void
  ): void {
    this.api.requestApi({
      callback,
      errorCallback: errorCallBack,
      body: { applicationID, email, applicantId, cellNumber, status },
      urlObj: ESign_api.UpdateOAOEsignStatus
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getESignStatus(envelopeId: string, callback: (l: Result<any>) => void, errorCallBack: (l) => void): void {
    this.api.requestApi({
      callback,
      errorCallback: errorCallBack,
      urlIds: { envelopeId },
      urlObj: ESign_api.GetESignStatus
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getKinectiveeSignStatus(
    applicationID: number,
    selectedApplicantEmail: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback: (l: Result<any>) => void,
    errorCallBack: (l) => void
  ): void {
    this.api.requestApi({
      callback,
      errorCallback: errorCallBack,
      body: { applicationID, selectedApplicantEmail },
      urlObj: ESign_api.GetKinectiveStatusIds
    });
  }

  /** Returns sign status by sessionId */
  public getKinectiveSignStatusBySession(
    kinectiveHostSessionID: string,
    selectedApplicantEmail: string,
    callback: (l: Result<string>) => void,
    errorCallBack: (l) => void
  ): void {
    this.api.requestApi({
      callback,
      errorCallback: errorCallBack,
      body: { kinectiveHostSessionID, selectedApplicantEmail },
      urlObj: ESign_api.GetKinectiveStatusBySession
    });
  }

  /**
   * getDocRepIds
   */
  public getDocRepIds(callback: (res: Result<string[]>) => void, errorCallBack?: () => void): void {
    this.api.requestApi({
      callback,
      errorCallback: errorCallBack,
      urlObj: ESign_api.GetDocRepIds
    });
  }

  /**
   * getIframeUrl
   */
  public getOAOIframeUrl(envelope, loginType, callback: (res: Result<EsignEnvelope>) => void, errorCallBack?: () => void): void {
    this.api.requestApi({
      body: envelope,
      callback,
      errorCallback: errorCallBack,
      urlIds: { loginType },
      urlObj: ESign_api.GetOAOIframeUrl
    });
  }

  /**
   * Complete Stipulation
   */
  public completeStipulation(
    stipulationList,
    callback: (res: Result<{ completeResults: [] }>) => void,
    errorCallBack?: (err) => void
  ): void {
    this.api.requestApi({
      body: stipulationList,
      callback,
      errorCallback: errorCallBack,
      urlObj: ESign_api.OAOCompleteStipulation
    });
  }

  public setTaskStatus(
    referenceType: string,
    referenceId: string,
    status: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback: (l: Result<any>) => void,
    errorCallBack: (l) => void
  ): void {
    this.api.requestApi({
      callback,
      errorCallback: errorCallBack,
      body: { referenceType, referenceId, status },
      urlObj: ESign_api.SetTaskStatus
    });
  }

  /**
   * RenewEsignUrl
   */
  public RenewEsignUrl(envelope: RenewEsignPayload, callback: (res: Result<string>) => void, errorCallback?: () => void): void {
    this.api.requestApi({
      body: envelope,
      callback,
      errorCallback,
      urlObj: ESign_api.RenewEsignUrl
    });
  }
}
